import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../assets/css/layout/donor/DonorSidebar.css";

const DonorSidebar = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const isActive = (path) => location.pathname === path;

  return (
    <div className={`donor-sidebar ${collapsed ? "collapsed" : ""}`}>

      {/* TOGGLE BUTTON */}
      <div className="sidebar-toggle" onClick={() => setCollapsed(!collapsed)}>
        ☰
      </div>

      {/* LOGO */}
      <div className="sidebar-logo">
        <div className="logo-icon">🎓</div>
        <span className="logo-text">Student Support Hub</span>
      </div>

      <nav className="sidebar-nav">

        <Link
          to="/donor/dashboard"
          className={`nav-item ${isActive("/donor/dashboard") ? "active" : ""}`}
        >
          <span className="nav-icon">📊</span>
          <span className="nav-text">Dashboard</span>
        </Link>

        <Link
          to="/donor/browse-cases"
          className={`nav-item ${isActive("/donor/browse-cases") ? "active" : ""}`}
        >
          <span className="nav-icon">📋</span>
          <span className="nav-text">Browse Cases</span>
        </Link>

        <Link
          to="/donor/donation-history"
          className={`nav-item ${isActive("/donor/donation-history") ? "active" : ""}`}
        >
          <span className="nav-icon">📜</span>
          <span className="nav-text">Donation History</span>
        </Link>

        <Link
          to="/donor/my-level"
          className={`nav-item ${isActive("/donor/my-level") ? "active" : ""}`}
        >
          <span className="nav-icon">🔔</span>
          <span className="nav-text">My Level</span>
        </Link>

        <Link
          to="/donor/my-rewards"
          className={`nav-item ${isActive("/donor/my-rewards") ? "active" : ""}`}
        >
          <span className="nav-icon">🎁</span>
          <span className="nav-text">My Rewards</span>
        </Link>

        <Link
          to="/donor/analytics"
          className={`nav-item ${isActive("/donor/analytics") ? "active" : ""}`}
        >
          <span className="nav-icon">📈</span>
          <span className="nav-text">Analytics</span>
        </Link>

        <Link
          to="/donor/support-ticket"
          className={`nav-item ${isActive("/donor/support-ticket") ? "active" : ""}`}
        >
          <span className="nav-icon">🎫</span>
          <span className="nav-text">Support Ticket</span>
        </Link>

      </nav>

      {/* LOGOUT */}
      <div className="sidebar-logout">
        <button
          className="logout-btn"
          onClick={() => {
            localStorage.removeItem("donorToken");
            localStorage.removeItem("donor_token");
            localStorage.removeItem("donor_user");
            localStorage.removeItem("donor_selected_case");
            localStorage.removeItem("preferredCause");
            navigate("/donor/login");
          }}
        >
          <span className="nav-icon">🚪</span>
          <span className="nav-text">Logout</span>
        </button>
      </div>

    </div>
  );
};

export default DonorSidebar;